// Component
import Head from "../Head";
import CampList from "../CampList";

export default function MenuHomeContent({ campSlot, campCasino, campSport }) {

    return (
        <>
            <div>
                <Head name="ค่ายเกมสล็อตยอดนิยม"></Head>
            </div>

            <div className="componentMarginTop">
                <CampList dataList={campSlot} typeCamp="slot"></CampList>
            </div>

            <div className="componentMarginTop">
                <Head name="คาสิโนสด บาคาร่า"></Head>
            </div>

            <div className="componentMarginTop">
                <CampList dataList={campCasino} typeCamp="casino"></CampList>
            </div>

            <div className="componentMarginTop">
                <Head name="กีฬา ฟุตบอล มวยไทย"></Head>
            </div>

            <div className="componentMarginTop">
                <CampList dataList={campSport} typeCamp="sport"></CampList>
            </div>
        </>
    );
}